import * as React from "react";
import { BlockText, Button } from "@nju/ui";

interface IFSecureOnboardingNotAllowedModal {
  onClose: () => void;
}

export function FSecureOnboardingNotAllowedModal({
  onClose,
}: IFSecureOnboardingNotAllowedModal) {
  React.useEffect(() => {
    return () => {
      onClose();
    };
  }, [onClose]);

  return (
    <div className="from-tablet:w-[780px]">
      <BlockText size="l">
        Bezpieczny internet możesz włączyć, gdy na Twoim koncie będzie aktywna{" "}
        <span className="font-bold">subskrypcja lub światłowód.</span>
      </BlockText>
      <BlockText className="my-6" size="l">
        Spróbuj ponownie, gdy jedna z tych usług będzie już aktywna.
      </BlockText>
      <Button onPress={onClose} size="m">
        ok
      </Button>
    </div>
  );
}
